import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const InitHome = () => {
  const stickyWrapper = document.querySelector('.sticky-wrapper');
  if (!stickyWrapper) return;

  const stickySection = stickyWrapper.querySelector('.sticky');
  if (!stickySection) return;

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: stickyWrapper,
      start: 'top top',
      end: 'bottom top',
      scrub: 1.5,
    },
  });
  tl.fromTo(stickySection, { y: '0%' }, { y: '+30%', ease: 'none' });
};

export default InitHome;
